module.exports = "<div class=\"form-group\" [formGroup]=\"form\">\n  <label [attr.for]=\"input.key\">{{ input.label }}</label>\n  <ng-select\n    [disabled]=\"disabled\"\n    [active]=\"selectedValue\"\n    [items]=\"input.options\"\n    [multiple]=\"input.multiple\"\n    (data)=\"refreshValue($event)\"\n    (selected)=\"selected($event)\"\n    [placeholder]=\"input.placeHolder\">\n  </ng-select>\n  <span\n    class=\"help-block text-muted\"\n    *ngIf=\"input.description!=''\"\n  >{{ input.description }}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/ng2-select/ng2-select.component.html
// module id = 1255
// module chunks = 13